<template>
    <div class="login-body">
        <div class="login-wrapper">
            <div class="login-panel">
                <router-link to="/" class="logo">
                    <img :src="require(`@/assets/images/prohealth.png`)" alt="ams-logo" class="" />
                </router-link>
                <div class="login-form">
                    <h2>Set Password</h2>
                    <p>Please set your password to log onto your account.</p>
                    <InputText maxlength = "255" type="password" autocomplete="off" placeholder="Enter Password" v-model="state.password_1" required="true" />
                    <InputText maxlength = "255" type="password" autocomplete="off" placeholder="Confirm Password" v-model="state.password_2" required="true" />
                    <Button label="Set Password" type="button" @click.prevent="setUserPassword"></Button>
                    <Toast />
                </div>
                <div class="requirements">
                    <br />
                    <strong> Password must meet the following requirements: </strong>
                    <ul>
                        <li>One uppercase</li>
                        <li>One lowercase</li>
                        <li>Symbols</li>
                        <li>Numbers</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useValidate from '@vuelidate/core';
import { reactive, computed } from 'vue';
import { mapGetters } from 'vuex';
import { passwordValidator } from '@/helpers/form-validators';

export default {
    name: 'SetPassword',
    data() {
        return {};
    },
    setup() {
        const state = reactive({
            password_1: null,
            password_2: null,
            token: null,
            mail_otp: null,
        });

        const rules = computed(() => {
            return {
                password_1: passwordValidator('Password'),
                password_2: passwordValidator('Confirm Password'),
            };
        });

        const v$ = useValidate(rules, state);

        return {
            state,
            v$,
        };
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn']),
    },
    mounted() {
        this.state.token = this.$route.query.token;
        this.state.mail_otp = this.$route.query.mail_otp;
    },
    methods: {
        async setUserPassword() {
            if (this.isValid()) {
                if (this.state.password_1 != this.state.password_2) {
                    this.setMessage('error', 'Input Errors', 'Confirm Password and Password values should be same');
                    return;
                }
                this.resetUserPassword();
            }
        },
        async resetUserPassword() {
            this.$store.dispatch('auth/resetPassword', this.state).then(() => {
                if (this.isLoggedIn) {
                    this.$router.push('/');
                }
            });
        },

        isValid() {
            this.v$.$validate();
            if (!this.v$.$error) {
                return true;
            }
            if (this.v$.password_1.$error) {
                this.setMessage('error', 'Input Errors', this.v$.password_1.$errors[0].$message);
            }
            if (this.v$.password_2.$error) {
                this.setMessage('error', 'Input Errors', this.v$.password_2.$errors[0].$message);
            }
        },
        responseOutput(res) {
            this.setMessage(res.severity, res.summary, res.message);
        },

        setMessage(type, summary, message) {
            this.$toast.add({ severity: type, summary: summary, detail: message, life: 5000 });
        },
    },
};
</script>

<style scoped>
.login-body .login-wrapper .login-panel {
    justify-content: center;
}

.row {
    display: flex;
    flex: wrap;
    margin: auto 2rem;
}

.requirements {
    text-align: left;
}
</style>
